import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Changelog18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path d='M9 3.75H18V2.25H9V3.75Z' fill='currentColor' />
    <path d='M9 9.75H18V8.25H9V9.75Z' fill='currentColor' />
    <path d='M18 15.75H9V14.25H18V15.75Z' fill='currentColor' />
    <path d='M2 15.75H5V14.25H2V15.75Z' fill='currentColor' />
    <path
      d='M0.469727 9.53033L1.53039 8.46967L2.75 9.68928V5C2.75 3.48122 3.98122 2.25 5.5 2.25H7V3.75H5.5C4.80964 3.75 4.25 4.30964 4.25 5V9.68939L5.46973 8.46967L6.53039 9.53033L3.50006 12.5607L0.469727 9.53033Z'
      fill='currentColor'
    />
  </Svg>
);

Changelog18.displayName = 'Changelog18';
export default Changelog18;
